import { render, staticRenderFns } from "./titleRibbon.vue?vue&type=template&id=7ccd19ba&scoped=true"
import script from "./titleRibbon.vue?vue&type=script&lang=js"
export * from "./titleRibbon.vue?vue&type=script&lang=js"
import style0 from "./titleRibbon.vue?vue&type=style&index=0&id=7ccd19ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccd19ba",
  null
  
)

export default component.exports